import { render } from "./VarOperationPropsCmp.vue?vue&type=template&id=98c84a22"
import script from "./VarOperationPropsCmp.vue?vue&type=script&lang=js"
export * from "./VarOperationPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__